import { gql, TypedDocumentNode } from '@apollo/client'
import { companyFragment } from './CompanyFragment'
import { contractDatumFragment } from './ContractDatumFragment'
import { countryFragment } from './CountryFragment'
import { workPostSheetFragment } from './WorkPostSheetFragment'
import type { PositionFragment } from './__generated__/PositionFragment'

export const positionFragment: TypedDocumentNode<PositionFragment> = gql`
  ${companyFragment}
  ${contractDatumFragment}
  ${countryFragment}
  ${workPostSheetFragment}

  fragment PositionFragment on Position {
    city
    company {
      ...CompanyFragment
    }
    contractDatum {
      ...ContractDatumFragment
    }
    country {
      ...CountryFragment
    }
    hasContracts
    description
    id
    latitude
    longitude
    minimumWage
    name
    nettoPremiumComment
    state
    street
    streetNumber
    studentsAllowed
    workPostSheet {
      ...WorkPostSheetFragment
    }
    wpsRequired
    zip
  }
`
